<template>
  <div class="selfservice-content-area hideOnLogout" v-if="showDashboard">
    <div class="invite">
      <SendKWKInvitation v-if="isEligible"
      :shareLink="shareLink"
      :invitationLoaded.sync="invitationLoaded"
      @loaded="checkAndDisableLoader"
      >
        <template v-for="slot in possibleChildSlotsFor('SendKWKInvitation')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </SendKWKInvitation>
      <div class="no-kwk-invitation" v-if="!isEligible">
        <h4><slot name="lblHeadlineNoInvitesSendKWKInvitation">KWK</slot></h4>
        <div v-if="ineligibilityReason === 'MAX_REFERRAL_COUNT_REACHED'">
          <slot name="lblSublineNoInvitesSendKWKInvitationReason1">MAX_REFERRAL_COUNT_REACHED</slot>
        </div>
        <div v-if="ineligibilityReason === 'DUNNING_LEVEL_TOO_HIGH'">
          <slot name="lblSublineNoInvitesSendKWKInvitationReason2">DUNNING_LEVEL_TOO_HIGH</slot>
        </div>
        <div v-if="!ineligibilityReason">
          <slot name="lblSublineNoInvitesSendKWKInvitationReason3">ALL_ANOTHER_REASON</slot>
        </div>
      </div>
    </div>
    <KwkDashboardReferals
      :properties-friend-referals="propertiesFriendReferals"
      :referalsLoaded.sync="referalsLoaded"
      @loaded="checkAndDisableLoader"
    >
      <template v-for="slot in possibleChildSlotsFor('KwkReferals')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
      </KwkDashboardReferals>
  </div>
  <div v-else-if="isAccessDenied" class="card no-access"><slot name="txtAccessDenied"></slot></div>
</template>

<script>

import SendKWKInvitation from '@/components/process/generic/Kwk/SendKWKInvitation.vue'
import KwkDashboardReferals from '@/components/process/generic/Kwk/KwkDashboardReferals.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

import { mapMutations } from 'vuex'

export default {
  name: 'SelfServiceKWKDashboardWrapper',
  props: {
    shareLink: {
      type: String,
      default: ''
    },
    propertiesFriendReferals: {
      type: String,
      default: ''
    },
    fallbackUrl: {
      Type: String,
      default: '/mein-simon/uebersicht'
    }
  },
  data () {
    return {
      error: null,
      loadedKWKState: false,
      invitationLoaded: false,
      referalsLoaded: false,
      currentCustomer: {
        contract: {
          state: null
        },
        friendReferralEligibility: {
          ineligibilityReason: '',
          isEligibleForReferral: true
        }
      }
    }
  },
  components: {
    SendKWKInvitation,
    KwkDashboardReferals
  },
  mounted () {
    this.startLoader()
  },
  methods: {
    ...mapMutations('kwk', [
      'setFallbackDashboardError'
    ]),
    checkAndDisableLoader () {
      if ((this.loadedKWKState && (!this.isEligible || this.invitationLoaded) && this.referalsLoaded) || this.isAccessDenied) {
        this.stopLoader()
      }
    },
    backToDashboard () {
      window.location.href = this.fallbackUrl
    }
  },
  computed: {
    isEligible () {
      const eligibility = this.currentCustomer?.friendReferralEligibility || undefined
      if (eligibility === undefined) {
        return false
      }
      return eligibility.isEligibleForReferral
    },
    ineligibilityReason () {
      if (!this.isEligible) {
        const reason = this.currentCustomer?.friendReferralEligibility?.ineligibilityReason
        if (reason !== null) {
          if (reason === 'MAX_REFERRAL_COUNT_REACHED' || reason === 'DUNNING_LEVEL_TOO_HIGH') {
            return this.currentCustomer?.friendReferralEligibility?.ineligibilityReason
          } else {
            return null
          }
        }
      }
      return null
    },
    contractTerminated () {
      const contract = this.currentCustomer?.contract || undefined
      if (contract === undefined) {
        return false
      }
      const contractTerminatedStates = ['TERMINATED_BY_SYSTEM', 'DISMISSED_BY_CUSTOMER', 'CANCELLED']
      if (contractTerminatedStates.includes(contract.state)) {
        document.querySelector('.ce_rsce_kwk_bonus_teaser').classList.add('display-none')
        return true
      }
      return false
    },
    showDashboard () {
      return !this.error && this.loadedKWKState && !this.contractTerminated
    },
    isAccessDenied () {
      return this.loadedKWKState && !this.showDashboard
    }
  },
  apollo: {
    currentCustomer: function () {
      this.startLoader()

      return wrapQuery(
        gql`
      query currentCustomer {
        currentCustomer {
          contract {
            state
          }
          friendReferralEligibility {
            ineligibilityReason
            isEligibleForReferral
          }
        }
      }
    `,
        this,
        ['currentCustomer'],
        {},
        () => {
          this.loadedKWKState = true

          if (this.isAccessDenied) {
            this.checkAndDisableLoader()
          }
          if (!this.isEligible) {
            this.invitationLoaded = true
            this.checkAndDisableLoader()
          }

          this.stopLoader()
        },
        {},
        (error) => {
          splitError(error).forEach((e) => {
            this.error = e.message
          })

          const data = {
            type: 'technical',
            message: this.error
          }

          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }

          this.setFallbackDashboardError(this.error)
          this.backToDashboard()

          this.stopLoader()
        }
      )
    }
  }
}
</script>
